import React from 'react';
// importing the form component
import Form from '../Form.js'

export default function Contact() {
  return (
    <div className='contact-page'>
      <h1>Send me a message</h1>
      {/* this is where the form component is brought into the Contact page */}
      <Form />
      <p>
       
       
      </p>
    </div>
  );
}
